import TextValueWithLoader from './TextValueWithLoader';

export default TextValueWithLoader;
